import React, { useEffect } from "react";
import { SectionCard } from "../../../Component/CustComponents/SectionCard";

import { useLocation } from "react-router-dom";
import Pagination from "../../../Component/Common/Pagination";
import RefreshButton from "../../../Component/Common/RefreshButton";
import RegularLoader from "../../../Component/Loader/RegularLoader";
import SimpleTable from "../../../Component/Common/SimpleTable";
import Badge from "../../../Component/Common/Badge";
import { BASE_URL } from "../../../config/api";
import axios from "axios";

export default function WarrantiesView() {
  const location = useLocation();
  const [customer, setCustomer] = React.useState(null);
const [devices, setDevices] = React.useState([]);
const [loading, setLoading] = React.useState(false);

  const filterStatus = location.state?.filterStatus || "all";
  const fromKPI = location.state?.fromKPI || false;

  const authUser = JSON.parse(localStorage.getItem("authUserData"));
  const customerId = authUser?.id;

  
  useEffect(() => {
  if (!customerId) return;

  const fetchCustomerDetails = async () => {

    try {

      setLoading(true);

      const response =
        await axios.get(
          `${BASE_URL}warranty/get-customer-details`,
          {
            params: {
              id: customerId,
            },

            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const json =
        response.data;

      setCustomer(json);

      setDevices(
        json?.devices || []
      );

    } catch (err) {

      console.error(
        "Failed to fetch customer details",
        err
      );

      setDevices([]);

    } finally {

      setLoading(false);

    }
  };

  fetchCustomerDetails();
}, [customerId]);


  const claims = [
    {
      id: "C-CLM-5001",
      warrantyId: "C-WAR-1001",
      productName: "Smartphone",
      issueSummary: "Device not powering on",
      raisedOn: "2025-10-10",
      status: "Approved",
      adminMessage: "Approved, pickup scheduled",
      lastUpdated: "2025-10-15",
      approvedAmount: 3500,
      payableAmount: 3000,
      payableStatus: "Paid",
    },
    {
      id: "C-CLM-5002",
      warrantyId: "C-WAR-0998",
      productName: "Smartphone",
      issueSummary: "Screen flickering",
      raisedOn: "2025-01-05",
      status: "Rejected",
      adminMessage: "Warranty expired.",
      lastUpdated: "2025-01-07",
      approvedAmount: 0,
      payableAmount: 0,
      payableStatus: "Not Applicable",
    },
  ];


  const deviceRows = React.useMemo(() => {
  return devices.map((d) => ({
    raw: d,
    cells: [
      {
        title: d.product_name || "—",
        sub: `${d.brand_name} · ${d.category_name}`,
        extra: `Model: ${d.model || "—"}`
      },
      d.imei1 || d.serial || "—",
      `₹${(d.device_price || 0).toLocaleString()}`,
      `₹${(d.product_price || 0).toLocaleString()}`,
      d.expiry_date,
      <Badge
        label={d.is_approved === 1 ? "Approved" : "REjected"}
        color={d.is_approved === 1 ? "green" : "red"}
      />
    ]
  }));
}, [devices]);


  // const filteredWarranties =
  // filterStatus === "all"
  //   ? warranties
  //   : warranties.filter((w) => w.status === filterStatus);


  // --------------------------
// Pagination
// --------------------------
const [currentPage, setCurrentPage] = React.useState(1);
const itemsPerPage = 2; // you can change this

const totalPages = Math.ceil(deviceRows.length / itemsPerPage);

const paginatedRows = React.useMemo(() => {
  const start = (currentPage - 1) * itemsPerPage;
  return deviceRows.slice(start, start + itemsPerPage);
}, [deviceRows, currentPage]);

  
  return (
    <div className="space-y-4">
     <SectionCard title="My Warranties / Devices">
     <div className="flex justify-end">
      <RefreshButton />
     </div>
  {loading ? (
    <div className="py-10 text-center text-xs text-slate-500">
     <RegularLoader/>
    </div>
  ) : (
    <SimpleTable
      headers={[
        "Product",
        "IMEI / Serial",
        "Device Price",
        "Plan Price",
        "Expiry",
        "Status"
      ]}
      rows={paginatedRows}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      showSrNo
      renderActions={(row) => (
        <a
          href={row?.raw?.certificate_link}
          target="_blank"
          rel="noreferrer"
          className="text-[11px] px-2 py-1 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100"
          onClick={(e) => e.stopPropagation()}
        >
          Certificate
        </a>
      )}

    />
  )}
</SectionCard>


      {!fromKPI && (
      <SectionCard title="Coverage Summary (Phones & Tablets)">
        <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
          <li>
            Warranty covers eligible hardware failures as per your plan (for
            example: power issues, motherboard faults, speaker issues, genuine
            touch / display problems).
          </li>
          <li>
            Items usually <span className="font-semibold">not covered</span>:
            physical damage, liquid damage, unauthorized repairs, or issues
            reported after expiry.
          </li>
          <li>
            Each certificate is linked to a specific device (IMEI / serial),
            invoice and purchase source.
          </li>
          <li>
            You can download your certificate for future reference anytime.
          </li>
        </ul>
      </SectionCard>
      )}
    </div>
  );
}



// import react from "react";
// import { SectionCard } from "../../../Component/CustComponents/SectionCard";
// import { Badge } from "../../../Component/CustComponents/Badge";
// export default function WarrantiesView({ warranties, claims }) {
//   return (
//     <div className="space-y-4">
//       <SectionCard title="My Warranties">
//         <div className="overflow-x-auto">
//           <table className="min-w-full text-xs">
//             <thead>
//               <tr className="border-b border-slate-100 text-slate-500">
//                 <th className="py-2 text-left">Warranty / Purchase</th>
//                 <th className="py-2 text-left">Device</th>
//                 <th className="py-2 text-left">Plan</th>
//                 <th className="py-2 text-left">Purchase From</th>
//                 <th className="py-2 text-left">Expiry</th>
//                 <th className="py-2 text-left">Status</th>
//                 <th className="py-2 text-left">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {warranties.map((w) => {
//                 const color =
//                   w.status === "Active"
//                     ? "green"
//                     : w.status === "Expired"
//                     ? "red"
//                     : "gray";

//                 const claimsForWarranty = claims.filter(
//                   (c) => c.warrantyId === w.id
//                 );

//                 return (
//                   <tr
//                     key={w.id}
//                     className="border-b border-slate-50 bg-white hover:bg-blue-50/60"
//                   >
//                     <td className="py-1.5 text-xs text-slate-700 font-medium">
//                       <div>{w.id}</div>
//                       <div className="text-[10px] text-slate-500">
//                         Purchase: {w.purchaseDate}
//                       </div>
//                     </td>
//                     <td className="py-1.5 text-xs text-slate-700">
//                       <div className="font-medium">{w.productName}</div>
//                       <div className="text-[10px] text-slate-500">
//                         {w.deviceType} · {w.model}
//                       </div>
//                       <div className="text-[10px] text-slate-500">
//                         Brand: {w.brand}
//                       </div>
//                       <div className="text-[10px] text-slate-500">
//                         IMEI / Serial: {w.serialOrImei}
//                       </div>
//                     </td>
//                     <td className="py-1.5 text-[11px] text-slate-700">
//                       {w.warrantyPlan}
//                     </td>
//                     <td className="py-1.5 text-[11px] text-slate-700">
//                       <div>{w.purchaseFromType}</div>
//                       <div className="text-[10px] text-slate-500">
//                         {w.purchaseFromName}
//                       </div>
//                       <div className="text-[10px] text-slate-400">
//                         Channel: {w.purchaseChannel}
//                       </div>
//                     </td>
//                     <td className="py-1.5 text-[11px] text-slate-700">
//                       {w.expiryDate}
//                     </td>
//                     <td className="py-1.5 text-xs">
//                       <Badge color={color}>{w.status}</Badge>
//                       {w.status === "Active" && (
//                         <div className="mt-1 text-[10px] text-slate-500">
//                           Claims used in coverage: {claimsForWarranty.length}
//                         </div>
//                       )}
//                     </td>
//                     <td className="py-1.5 text-[11px] text-slate-700">
//                       <div className="flex flex-col gap-1">
//                         <button className="text-[11px] px-2 py-1 rounded-lg border border-blue-200 text-blue-700 bg-blue-50 hover:bg-blue-100">
//                           Download Certificate
//                         </button>
//                         <button className="text-[10px] px-2 py-1 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100">
//                           View Coverage Details
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//               {warranties.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={7}
//                     className="py-4 text-center text-xs text-slate-500"
//                   >
//                     No warranties found for this account.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </SectionCard>

//       <SectionCard title="Coverage Summary (Phones & Tablets)">
//         <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
//           <li>
//             Warranty covers eligible hardware failures as per your plan (for
//             example: power issues, motherboard faults, speaker issues, genuine
//             touch / display problems).
//           </li>
//           <li>
//             Items usually <span className="font-semibold">not covered</span>:
//             physical damage, liquid damage, unauthorized repairs, use of
//             non-original accessories, or issues reported after expiry.
//           </li>
//           <li>
//             Each certificate is linked to a specific device (IMEI / serial),
//             invoice and purchase source (retailer, online portal or channel
//             partner).
//           </li>
//           <li>
//             You can use "Download Certificate" to keep a PDF copy of your
//             warranty details for future reference (invoice, coverage and
//             validity).
//           </li>
//         </ul>
//       </SectionCard>
//     </div>
//   );
// }